import { render, staticRenderFns } from "./DrivewealthDocumentsPage.vue?vue&type=template&id=115973e8"
import script from "./DrivewealthDocumentsPage.vue?vue&type=script&lang=ts"
export * from "./DrivewealthDocumentsPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports